import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { NilaiSiswaPage } from './nilai-siswa.page';
import { MenuKelas } from './nilai-siswa.page';
import { DetailNilaiPage } from '../detail-nilai/detail-nilai.page';

const routes: Routes = [
  {
    path: '',
    component: NilaiSiswaPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [NilaiSiswaPage,MenuKelas,DetailNilaiPage ],
  entryComponents:[MenuKelas,DetailNilaiPage ]
})
export class NilaiSiswaPageModule {}
